<template>
  <div class="dropdown">
    <select v-model="dropdownValue">
      <option :value="''">Choose one</option>
      <option v-for="value in values" :value="value">{{ value }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'dropdown',
  props: [ 'settingKey', 'values' ],
  computed: {
    dropdownValue: {
      get () {
        let configuration = this.$store.state.settingsPage.configuration
        if (this.settingKey in configuration) {
          let result = configuration[this.settingKey].value
          return configuration[this.settingKey].value
        }
        return ''
      },
      set (value) {
        let item = {
          key: this.settingKey,
          value: value
        }
        this.$store.commit('settingsPage/setConfigurationItem', item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
select {
  font-size: 14px;
  height: 37px;
  outline: 0;
  padding: 7px 10px;
  display: inline-block;
  width: 100%;
  max-width: 200px;
  border-color: rgba(0,0,0,0.15);
  background-color: #fff;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/controls/Dropdown.vue